import { Redirect, Route, Switch } from "react-router-dom";
import { SettingsPage } from "pages/settings/SettingsPage";
import { RolePage } from "pages/settings/RolePage";
import { EntitlementPage } from "pages/settings/EntitlementPage";
import { UserPage } from "pages/settings/UserPage";
import { ComponentPage } from "pages/settings/ComponentPage";
import { ScalarConfigurationPage } from "pages/settings/ScalarConfigurationPage";
import { TagsPage } from "pages/settings/TagsPage";
import { MachinesPage } from "pages/settings/MachinesPage";
import { MachineModelsPage } from "pages/settings/MachineModelPage";
import { ManufacturerPage } from "pages/settings/ManufacturerPage";
export const SettingsRoutes = (): JSX.Element => {
  return (
    <Switch>
      <Route exact path="/pages/settings">
        <SettingsPage />
      </Route>
      <Route exact path="/pages/settings/role/:id">
        <RolePage />
      </Route>
      <Route exact path="/pages/settings/entitlement/:id">
        <EntitlementPage />
      </Route>
      <Route exact path="/pages/settings/user/:id">
        <UserPage />
      </Route>
      <Route exact path="/pages/settings/component/:id">
        <ComponentPage />
      </Route>
      <Route exact path="/pages/settings/scalar_configuration/:id">
        <ScalarConfigurationPage />
      </Route>
      <Route exact path="/pages/settings/tag/:id">
        <TagsPage />
      </Route>
      <Route exact path="/pages/settings/machine/:id">
        <MachinesPage />
      </Route>
      <Route exact path="/pages/settings/machine_model/:id">
        <MachineModelsPage />
      </Route>
      <Route exact path="/pages/settings/manufacturer/:id">
        <ManufacturerPage />
      </Route>
      {/* Redirect to the closest exact path above when an incorrect url is entered*/}
      <Redirect to="/pages/settings/role/:id" from="/pages/settings/role/:id" />
      <Redirect
        to="/pages/settings/entitlement/:id"
        from="/pages/settings/entitlement/:id"
      />
      <Redirect to="/pages/settings/user/:id" from="/pages/settings/user/:id" />
      <Redirect to="/pages/settings" from="/pages/settings" />
      <Redirect to="/pages" />
    </Switch>
  );
};
